(async () => {
  if (!('serviceWorker' in navigator)) return;

  try {
    // Unregister ALL SW registrations for this origin
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map(r => r.unregister()));

    // Also nuke common SW caches (ngsw uses Cache Storage)
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map(k => caches.delete(k)));
    }
  } catch (e) {
    // don't block app load
    // eslint-disable-next-line no-console -- intentional warning; do not block app load on SW cleanup failure
    console.warn('SW kill failed:', e);
  }
})();
